import { Checkbox, Card, Layout, Drawer, Button, Space, Row, Col, Select, ColorPicker, Radio, Popconfirm } from 'antd';
import { useEffect, useRef, useState } from 'react';
import arrayHandle from "../../../utils/baseLib/arrayHandle";
import { useReactToPrint } from 'react-to-print';

const { Content, Sider } = Layout;

//组件 CustomPrint 
export default async function CustomPrint(props: any) {

    //配置参数
    const { closeModal, reserveMenuData } = props; //从父组件传来
    const contentRef = useRef<HTMLDivElement>(null);

    const [htmlData, setHtmlData] = useState<any>()

    const [fontSizeData, setFontSizeData] = useState<any>([
        { value: '12px', label: '12px' },
        { value: '14px', label: '14px' },
        { value: '16px', label: '16px' },
        { value: '18px', label: '18px' },
        { value: '20px', label: '20px' },
        { value: '22px', label: '22px' },
        { value: '24px', label: '24px' },
    ]);

    const [widthData, setWidthData] = useState<any>([
        { value: '10%', label: '10%' },
        { value: '20%', label: '20%' },
        { value: '30%', label: '30%' },
        { value: '40%', label: '40%' },
        { value: '50%', label: '50%' },
        { value: '60%', label: '60%' },
        { value: '70%', label: '70%' },
        { value: '80%', label: '80%' },
        { value: '90%', label: '90%' },
        { value: '100%', label: '100%' },
    ]);

    const [lineHeightData, setLineHeightData] = useState<any>([
        { value: '80%', label: '80%' },
        { value: '90%', label: '90%' },
        { value: '100%', label: '100%' },
        { value: '110%', label: '110%' },
        { value: '120%', label: '120%' },
        { value: '130%', label: '130%' },
        { value: '140%', label: '140%' },
        { value: '150%', label: '150%' },
        { value: '160%', label: '160%' },
        { value: '170%', label: '170%' },
    ]);

    const alignOptions = [
        { label: '左', value: 'left' },
        { label: '中', value: 'center' },
        { label: '右', value: 'right' },
    ];

    const [backgroundModeData, setBackgroundModeData] = useState<any>([
        { value: '1', label: '使用底图' },
        { value: '2', label: '使用底色' },
    ]);

    const [logoModeData, setlogoModeData] = useState<any>([
        { value: '1', label: '正常LOGO' },
        { value: '2', label: '反色LOGO' },
    ]);

    const [reserveMenuModuleData, setReserveMenuModuleData] = useState<any>([
        {
            id: 'logo',
            name: 'LOGO',
            style: {
                logoMode: "1",
                width: "30%"
            },
            checked: true,
            disabled: false
        },
        {
            id: 'body',
            name: '模式',
            style: {
                backgroundMode: "2",
                color: "#fffcdb",
            },
            checked: true,
            disabled: true
        },
        {
            id: 'title',
            name: '标题',
            style: {
                textAlign: "center",
                color: "#111111",
                fontSize: "16px"
            },
            checked: true,
            disabled: false
        },
        {
            id: 'subtitle',
            name: '副标题',
            style: {
                textAlign: "center",
                color: "#646464",
                fontSize: "12px"
            },
            checked: true,
            disabled: false
        },
        {
            id: 'detail',
            name: '菜式间距',
            style: {
                lineHeight: "100%"
            },
            checked: true,
            disabled: true
        },
        {
            id: 'category',
            name: '分类',
            style: {
                textAlign: "center",
                color: "#c13b38",
                fontSize: "14px"
            },
            checked: true,
            disabled: true
        },
        {
            id: 'foodName',
            name: '菜式',
            style: {
                textAlign: "center",
                color: "#323232",
                fontSize: "12px"
            },
            checked: true,
            disabled: true
        },
        {
            id: 'serviceCharge',
            name: '服务费',
            style: {
                textAlign: "center",
                color: "#ff0000",
                fontSize: "12px"
            },
            checked: true,
            disabled: false
        },
        {
            id: 'footnote',
            name: '脚注',
            style: {
                textAlign: "center",
                color: "#c13b38",
                fontSize: "12px"
            },
            checked: true,
            disabled: false
        },
        {
            id: 'subFootnote',
            name: '副脚注',
            style: {
                textAlign: "center",
                color: "#0000ff",
                fontSize: "12px"
            },
            checked: true,
            disabled: false
        },
        {
            id: 'menuEnding',
            name: '菜单末图片',
            style: {
                width: "100%"
            },
            checked: true,
            disabled: false
        },
    ]);

    useEffect(() => {
        const fetchData = async () => {
            if (localStorage.getItem('reserveMenuPrint')) {
                let localStorageData: any = localStorage.getItem('reserveMenuPrint');
                setReserveMenuModuleData(JSON.parse(localStorageData));
                await convertHtml(reserveMenuData, JSON.parse(localStorageData));
            }
            else {
                await saveStorage(reserveMenuModuleData);
                await convertHtml(reserveMenuData, reserveMenuModuleData);
            }
        };

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //打开打印菜单
    const handleOk = async (record: any) => {
        await saveStorage(reserveMenuModuleData);
        print();
    }

    //打印模块
    const print = useReactToPrint({
        contentRef,
    })

    const handleCancel = () => {
        closeModal(false);
    };

    const convertHtml = async (data: any, moduleStyle: any) => {
        let moduleData: any = {
            body: '<div style=@bodyStyle>@body</div>',
            logo: '<img style=@logoStyle src=@logo></img>',
            title: '<div style=@titleStyle>@title</div>',
            subtitle: '<div style=@subtitleStyle>@subtitle</div>',
            detail: '<div style=@detailStyle>@detail</div>',
            category: '<div style=@categoryStyle>@category</div>',
            foodName: '<div style=@foodNameStyle>@foodName</div>',
            serviceCharge: '<div style=@serviceChargeStyle>@serviceCharge</div>',
            footnote: '<div style=@footnoteStyle>@footnote</div>',
            subFootnote: '<div style=@subFootnoteStyle>@subFootnote</div>',
            menuEnding: '<img style=@menuEndingStyle src=@menuEnding></img>'
        };

        let jpg = {
            logoJpg: data.branchStore.brandLogo,
            reserveMenuLogo: data.branchStore.reserveMenuLogo,
            reserveMenuLogoInvert: data.branchStore.reserveMenuLogoInvert,
            menuEnding: data.branchStore.reserveMenuEnding
        }

        // 处理各参数的样式
        for (var i = 0; i < moduleStyle.length; i++) {
            let reserveMenuModuleSyle = moduleStyle[i].style;
            let styleData = '';
            let keyData = Object.keys(reserveMenuModuleSyle);

            switch (moduleStyle[i].id) {
                case 'body':
                    styleData = 'width: 103%;height: 100vh;text-align: center;';
                    break

                case 'title':
                    styleData = 'margin-bottom: 8px;font-weight: bold;';
                    break

                case 'subtitle':
                    styleData = 'margin-bottom: 8px;';
                    break;

                case 'detail':
                    styleData = 'margin-top: 7px;margin-bottom: 10px;';
                    break;
            }

            for (var s = 0; s < keyData.length; s++) {
                let key = keyData[s];
                switch (key) {
                    case 'fontSize':
                        styleData += "font-size: " + reserveMenuModuleSyle[key] + ";"
                        break;

                    case 'backgroundMode':
                        if (reserveMenuModuleSyle[key] === '1' && data.reserveMenuModel.backgroundSrc) {
                            styleData += "width: 103%;background-size: 100%;background-image: url(" + data.reserveMenuModel.backgroundSrc + ");"
                        }
                        break;

                    case 'color':
                        if (moduleStyle[i].id === 'body') {
                            if (reserveMenuModuleSyle['backgroundMode'] === '2') {
                                styleData += "background-color: " + reserveMenuModuleSyle[key] + ";"
                            }
                        }
                        else {
                            styleData += "color: " + reserveMenuModuleSyle[key] + ";"
                        }
                        break;

                    case 'textAlign':
                        styleData += "text-align: " + reserveMenuModuleSyle[key] + ";"
                        break;

                    case 'width':
                        styleData += "width: " + reserveMenuModuleSyle[key] + ";"
                        break;

                    case 'lineHeight':
                        styleData += "line-height: " + reserveMenuModuleSyle[key] + ";"
                        break;
                }

            }
            let tempData = moduleData[moduleStyle[i].id];

            if (tempData) {
                let replaceData = tempData.replace(new RegExp("@" + moduleStyle[i].id + "Style", "gm"), '"' + styleData + '"');
                moduleData[moduleStyle[i].id] = replaceData;
            }
        }

        // 处理各分类和菜式
        let reserveMenuPrivateCategorys = data.reserveMenuDetail.reserveMenuPrivateCategorys;
        let reserveMenuDetailStyle: any = '';
        for (var k = 0; k < reserveMenuPrivateCategorys.length; k++) {
            let reserveMenuDetailStyleData: any = '';
            reserveMenuDetailStyleData += moduleData.category.replace(new RegExp("@category", "gm"), reserveMenuPrivateCategorys[k].reserveMenuCategory.reserveMenuCategoryName);

            let reserveMenuDetails = reserveMenuPrivateCategorys[k].reserveMenuDetails;
            for (var m = 0; m < reserveMenuDetails.length; m++) {
                let extendParameters = JSON.parse(reserveMenuDetails[m].extendParameters);
                let showExtendParameters: any = '';
                let showInMenu = false;

                if (extendParameters) {
                    showInMenu = JSON.parse(reserveMenuDetails[m].extendParameters)?.showInMenu ? (JSON.parse(reserveMenuDetails[m].extendParameters)?.showInMenu) : showInMenu;
                    showExtendParameters += JSON.parse(reserveMenuDetails[m].extendParameters)?.showAmount ? " " + reserveMenuDetails[m].amount : "";
                    showExtendParameters += JSON.parse(reserveMenuDetails[m].extendParameters)?.showProductUnit ? reserveMenuDetails[m].productUnitName : "";

                    showExtendParameters = " " + showExtendParameters;
                }

                if (showInMenu) {
                    reserveMenuDetailStyleData += moduleData.foodName.replace(new RegExp("@foodName", "gm"), (reserveMenuDetails[m].otherFoodName ? (reserveMenuDetails[m].otherFoodName + showExtendParameters) : (reserveMenuDetails[m].menuSpec.menu.foodName + showExtendParameters)));
                }
            }
            reserveMenuDetailStyle += moduleData.detail.replace(new RegExp("@detail", "gm"), reserveMenuDetailStyleData);
        }

        // 处理服务费的前后缀
        let findServiceCharge: any = await arrayHandle.findValue(data.reserveMenuDetail.reserveMenuModel.reserveMenuStyles, 'reserveMenuModuleId', 'serviceCharge');
        let serviceCharge: any;
        if (findServiceCharge) {
            let serviceChargeData = JSON.parse(findServiceCharge.data.extendParameters);
            serviceCharge = data.serviceCharge ? (serviceChargeData.addonBefore + data.serviceCharge + serviceChargeData.addonAfter) : '';
        }

        let jpgDiv = '<div style="text-align: center;">@jpgDiv</div>';
        let blank = '<div style="height: 20px;"> </div>';

        // 组合各模块，生成html内容
        let htmlDatas: any = '';
        htmlDatas += blank;

        if (await checkState(moduleStyle, 'logo', 'state')) {
            if (await checkState(moduleStyle, 'logo', 'value') === '1') {
                htmlDatas += jpgDiv.replace(new RegExp("@jpgDiv", "gm"), moduleData.logo.replace(new RegExp("@logo", "gm"), '"' + (jpg.reserveMenuLogo ? jpg.reserveMenuLogo : jpg.logoJpg) + '"'));
            }
            else {
                htmlDatas += jpgDiv.replace(new RegExp("@jpgDiv", "gm"), moduleData.logo.replace(new RegExp("@logo", "gm"), '"' + (jpg.reserveMenuLogoInvert ? jpg.reserveMenuLogoInvert : jpg.logoJpg) + '"'));
            }
        }

        if (await checkState(moduleStyle, 'title', 'state') && data.title) {
            htmlDatas += moduleData.title.replace(new RegExp("@title", "gm"), data.title);
        }

        if (await checkState(moduleStyle, 'subtitle', 'state') && data.subtitle) {
            htmlDatas += moduleData.subtitle.replace(new RegExp("@subtitle", "gm"), data.subtitle);
        }

        htmlDatas += reserveMenuDetailStyle;

        if (await checkState(moduleStyle, 'serviceCharge', 'state') && data.serviceCharge) {
            htmlDatas += moduleData.serviceCharge.replace(new RegExp("@serviceCharge", "gm"), serviceCharge);
        }

        if (await checkState(moduleStyle, 'footnote', 'state') && data.footnote) {
            htmlDatas += moduleData.footnote.replace(new RegExp("@footnote", "gm"), await checkPrice(data, 'footnote'));
        }

        if (await checkState(moduleStyle, 'subFootnote', 'state') && data.subFootnote) {
            htmlDatas += moduleData.subFootnote.replace(new RegExp("@subFootnote", "gm"), await checkPrice(data, 'subFootnote'));
        }

        if (await checkState(moduleStyle, 'menuEnding', 'state') && jpg.menuEnding) {
            htmlDatas += jpgDiv.replace(new RegExp("@jpgDiv", "gm"), moduleData.menuEnding.replace(new RegExp("@menuEnding", "gm"), '"' + jpg.menuEnding + '"'));
        }

        setHtmlData(moduleData.body.replace(new RegExp("@body", "gm"), htmlDatas));
    };

    /**
       * 检查字段中是否有@price，如果有就进行替换
       * @param data
       * @param key 需要对那个位置进行检查
       */
    const checkPrice = async (data: any, key: any) => {
        let returnData: any;
        if (data[key]) {
            let count = (data[key].match(/@price/g) || []).length;
            if (count) {
                returnData = data[key].replace(new RegExp("@price", "gm"), '' + data.originalPrice + '');
            }
            else {
                returnData = data[key];
            }
        }
        return returnData;
    }

    /**
       * 检查reserveMenuModuleData的状态或者值，并返回
       * @param data
       * @param key 需要对那个位置检查
       * @param returnData 返回的是【状态】还是【值】
       */
    const checkState = async (data: any, key: any, returnData: any) => {
        let state = false;
        let findData: any;
        let finalData: any;
        switch (returnData) {
            case 'state':
                findData = await arrayHandle.findValue(data, 'id', key);
                if (findData) {
                    state = findData.data.checked;
                }
                return state;

            case 'value':
                findData = await arrayHandle.findValue(data, 'id', key);
                let temp = key + 'Mode';
                if (findData) {
                    finalData = findData.data.style[temp];
                }
                return String(finalData);
        }
    }

    const handleChangeStyle = async (index: any, key: any, e: any, checked: boolean) => {
        let finalData;
        switch (key) {
            case 'color':
                finalData = e.toHexString();
                break
            case 'textAlign':
                finalData = e.target.value;
                break
            default:
                finalData = e;
                break
        }

        reserveMenuModuleData[index].style[key] = finalData;
        setReserveMenuModuleData(reserveMenuModuleData);
        if (checked) {
            await convertHtml(reserveMenuData, reserveMenuModuleData);
        }
    }

    const showModule = async (key: any, index: any, checked: boolean) => {
        switch (key) {
            case 'fontSize':
                return (
                    <div>
                        字号：<Select
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            style={{ width: 135 }}
                            onChange={(e) => handleChangeStyle(index, key, e, checked)}
                            options={fontSizeData}
                        />
                    </div>
                );

            case 'color':
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        颜色：<ColorPicker
                            style={{ width: 135 }}
                            onChangeComplete={(e) => handleChangeStyle(index, key, e, checked)}
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            disabledAlpha
                            showText
                        />
                    </div>
                );

            case 'textAlign':
                return (
                    <div>
                        对齐：<Radio.Group
                            options={alignOptions}
                            onChange={(e) => handleChangeStyle(index, key, e, checked)}
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </div>
                );

            case 'width':
                return (
                    <div>
                        宽度：<Select
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            style={{ width: 135 }}
                            onChange={(e) => handleChangeStyle(index, key, e, checked)}
                            options={widthData}
                        />
                    </div>
                );

            case 'lineHeight':
                return (
                    <div>
                        间距：<Select
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            style={{ width: 135 }}
                            onChange={(e) => handleChangeStyle(index, key, e, checked)}
                            options={lineHeightData}
                        />
                    </div>
                );

            case 'backgroundMode':
                return (
                    <div>
                        模式：<Select
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            style={{ width: 135 }}
                            onChange={(e) => handleChangeStyle(index, key, e, checked)}
                            options={backgroundModeData}
                        />
                    </div>
                );

            case 'logoMode':
                return (
                    <div>
                        色系：<Select
                            defaultValue={reserveMenuModuleData[index].style[key]}
                            style={{ width: 135 }}
                            onChange={(e) => handleChangeStyle(index, key, e, checked)}
                            options={logoModeData}
                        />
                    </div>
                );
        }
    }

    /**
     * 选择卡片时触发（多选）
     */
    const onChangeCheckCard = async (parameters: any) => {
        reserveMenuModuleData[parameters.index].checked = !parameters.checked;
        setReserveMenuModuleData(reserveMenuModuleData);
        await convertHtml(reserveMenuData, reserveMenuModuleData);
    };

    const saveStorage = async (reserveMenuModuleData: any) => {
        // 先把原来的reserveMenuPrint内容删除，再重新把内容加到本地浏览器里面
        localStorage.removeItem("reserveMenuPrint");
        localStorage.setItem('reserveMenuPrint', JSON.stringify(reserveMenuModuleData));
    }

    const removeStorage = () => {
        // 先把原来的reserveMenuPrint内容删除
        localStorage.removeItem("reserveMenuPrint");
    }

    return (
        <>
            <Drawer
                title='自定义打印'
                placement="right"
                width='100%'
                open={true}
                maskClosable={false}
                closable={false}
                keyboard={false}
                onClose={handleCancel}
                extra={
                    <Space>
                        <Popconfirm title="确定清除配置好的样式吗？清除后所有参数需要重新设置。" onConfirm={removeStorage}>
                            <Button danger>清除储存样式</Button>
                        </Popconfirm>
                        <Button onClick={handleCancel}>取消</Button>
                        <Button onClick={handleOk} type="primary">去打印</Button>
                    </Space>
                }
            >
                <Layout>
                    <Sider width="30%" style={{ background: "#fff" }}>
                        <div ref={contentRef} dangerouslySetInnerHTML={{ __html: htmlData }} />
                    </Sider>
                    <Content style={{ background: "#fff" }}>
                    </Content>
                    <Sider width="68%" style={{ margin: '10px' }}>
                        <div style={{ padding: 0, textAlign: 'center' }}>
                            <Row gutter={[16, 24]}>
                                {
                                    reserveMenuModuleData.map(async (item: any, index: any) => {
                                        let keyData = Object.keys(item.style);
                                        return (
                                            <Col span={8}>
                                                <Card
                                                    title={item.name}
                                                    actions={[
                                                        <Checkbox disabled={item.disabled} defaultChecked={item.checked} onChange={() => onChangeCheckCard({
                                                            id: item.id,
                                                            name: item.name,
                                                            checked: item.checked,
                                                            index
                                                        })}>勾选</Checkbox>,
                                                    ]
                                                    }
                                                >
                                                    <Space direction="vertical" style={{ width: '100%' }} size="middle">
                                                        {keyData.map((items: any) => {
                                                            return (
                                                                <div>{showModule(items, index, item.checked)}</div>
                                                            )
                                                        })}
                                                    </Space>
                                                </Card>
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                        </div>
                    </Sider>
                </Layout>
            </Drawer>
        </>
    );
}